import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { TASK_CATEGORIES } from '../../../data/taskData';
import { useLanguage } from '../../../contexts/LanguageContext';

const COLORS = { Safety: '#ef4444', Quality: '#3b82f6', Operations: '#f59e0b', Documentation: '#8b5cf6' };

const CategoryBreakdown = ({ tasks = [] }) => {
  const { t } = useLanguage();
  const data = TASK_CATEGORIES?.map(cat => {
    const catTasks = tasks?.filter(t => t?.category === cat);
    const done = catTasks?.filter(t => t?.status === 'completed')?.length;
    return { name: cat, total: catTasks?.length, done, rate: catTasks?.length > 0 ? Math.round((done / catTasks?.length) * 100) : 0 };
  })?.filter(d => d?.total > 0);

  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const d = payload?.[0]?.payload;
    return (
      <div className="bg-card border border-border rounded-xl shadow-elevation-2 p-3">
        <p className="text-xs font-semibold text-foreground">{d?.name}</p>
        <p className="text-sm font-bold" style={{ color: COLORS?.[d?.name] }}>{d?.rate}%</p>
        <p className="text-xs text-muted-foreground">{d?.done}/{d?.total} {t('tasks')}</p>
      </div>
    );
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-elevation-2 overflow-hidden h-full">
      <div className="px-5 py-4 border-b border-border">
        <h3 className="font-semibold text-foreground font-heading">{t('byCategory')}</h3>
        <p className="text-xs text-muted-foreground mt-0.5">{t('todayTaskDistribution')}</p>
      </div>
      <div className="p-5">
        {data?.length > 0 ? (
          <>
            <ResponsiveContainer width="100%" height={160}>
              <PieChart>
                <Pie data={data} cx="50%" cy="50%" innerRadius={45} outerRadius={70} dataKey="total" paddingAngle={3}>
                  {data?.map(entry => <Cell key={entry?.name} fill={COLORS?.[entry?.name]} />)}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>
            <div className="space-y-2 mt-3">
              {data?.map(d => (
                <div key={d?.name} className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: COLORS?.[d?.name] }} />
                    <span className="text-xs font-medium text-foreground">{d?.name}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-muted-foreground">{d?.done}/{d?.total}</span>
                    <span className={`text-xs font-bold ${d?.rate >= 80 ? 'text-emerald-600' : d?.rate >= 50 ? 'text-amber-600' : 'text-red-600'}`}>{d?.rate}%</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="py-8 text-center"><p className="text-sm text-muted-foreground">{t('noTaskDataToday')}</p></div>
        )}
      </div>
    </div>
  );
};

export default CategoryBreakdown;
